import { render, staticRenderFns } from "./MovementsIndex.vue?vue&type=template&id=a53da092"
import script from "./MovementsIndex.vue?vue&type=script&lang=js"
export * from "./MovementsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53da092')) {
      api.createRecord('a53da092', component.options)
    } else {
      api.reload('a53da092', component.options)
    }
    module.hot.accept("./MovementsIndex.vue?vue&type=template&id=a53da092", function () {
      api.rerender('a53da092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/MovementsIndex.vue"
export default component.exports